import React from 'react'
import Text from '../../../atoms/text/Text'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'

import './ArrowHeader.scss'

interface Props {
  text: string
  colour: string
}

const ArrowHeader: React.FC<Props> = ({
  text,
  colour
}) => {

  return (
    <InlineGroup className='arrow-header' style={{backgroundColor: colour}}>
      <Text size='2xl' bold colour='white'>{text}</Text>
      <span className='arrow-header-point' style={{backgroundColor: colour}}></span>
    </InlineGroup>
  )
}

export default ArrowHeader